export const mapValuationDataToViewFields = valuationData => ({
  areaName: valuationData.area_name,
  price: valuationData.price_estimate_main,
  pricePerSquareFoot: valuationData.price_estimate_per_sqft,
  pricePerSquareFootInArea: valuationData.neighborhood_sale_price_per_sqft,
  priceRangeEnd: valuationData.price_estimate_high,
  priceRangeStart: valuationData.price_estimate_low,
  rentPrice: valuationData.rent_estimate_main
});
